import * as Types from "../types";
import isActive from "./isActive";

interface GetActiveItem {
  activePrimary: string;
  activeSecondary?: string;
  activeTertiary?: string;
}

const getActiveItem = (items: Types.Item[], currentPath: string): GetActiveItem => {
  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // When has no secondary menu and it's active (eg. dashboard)
    if (isActive(item, currentPath)) {
      return {
        activePrimary: item.id,
      };
    }

    if (item.subMenu?.length) {
      for (let i = 0; i < item.subMenu.length; i++) {
        const subItem = item.subMenu[i];

        // When has secondary menu and it's active (eg. invitations)
        if (isActive(subItem, currentPath)) {
          return {
            activePrimary: item.id,
            activeSecondary: subItem.id,
          };
        }

        const activeTertiary =
          subItem.subMenu && Array.isArray(subItem.subMenu) && subItem?.subMenu?.find((i) => isActive(i, currentPath));

        // When has tertiary menu and it's active (eg. analytics)
        if (activeTertiary) {
          return {
            activePrimary: item.id,
            activeSecondary: subItem.id,
            activeTertiary: activeTertiary.id,
          };
        }
      }
    }
  }

  return null;
};

export default getActiveItem;
